import { Link } from "eddev/routing"

export const BackButton = ({ href, children }: { href: string; children: React.ReactNode }) => {
  return (
    <Link href={href} className="flex gap-2 items-center w-full type-ui-label">
      <svg className="w-4 h-4" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.38729 10.4877C6.20424 10.3046 6.20424 10.0079 6.38729 9.82479L11.0748 5.13729C11.2579 4.95424 11.5546 4.95424 11.7377 5.13729C11.9208 5.32035 11.9208 5.61715 11.7377 5.80021L7.38166 10.1562L11.7377 14.5123C11.9208 14.6954 11.9208 14.9921 11.7377 15.1752C11.5546 15.3583 11.2579 15.3583 11.0748 15.1752L6.38729 10.4877Z"
          fill="currentColor"
        />
      </svg>
      {children}
    </Link>
  )
}
